// extracted by mini-css-extract-plugin
export default {"advice":"advice_advice__KdDb5","warning":"advice_warning__mn+Dk"};